import React from 'react';
import * as RadixSelect from '@radix-ui/react-select';
import classNames from 'classnames';
import { TPillSelectOptionBase } from 'types/ui';

import { Pill } from '../../Pill/Pill';

import styles from './SelectItem.module.scss';

export interface ISelectItemProps extends RadixSelect.SelectItemProps {
    option: TPillSelectOptionBase;
}

export const SelectItem: React.FC<ISelectItemProps> = ({ children, className, option, ...props }) => {
    return (
        <RadixSelect.Item className={classNames(styles.selectItem, className)} {...props}>
            <Pill
                prefix={option.icon}
                className={styles.pill}
                style={{
                    backgroundColor: option.backgroundColor,
                    color: option.color,
                }}
            >
                <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
            </Pill>
        </RadixSelect.Item>
    );
};
